import { render, staticRenderFns } from "./CreateFormCoupon.vue?vue&type=template&id=e0165ea6"
import script from "./CreateFormCoupon.vue?vue&type=script&lang=js"
export * from "./CreateFormCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports